@if (!isCandidateDataVisible) {
  <rt-avatar
    shape="oval"
    size="small"
    type="icon"
    iconName="visibility-off"
    customIconBackgroundColor="colorAvatarSteelLighter"
    customIconColor="colorIconOnprimaryDefault"
    context="admin"
  />
} @else {
  <rt-avatar
    [type]="event.candidate.hasAvatar ? 'image' : 'initials'"
    [initials]="event.candidate.initials"
    [size]="'small'"
    [shape]="'oval'"
    [imageSrc]="event.candidate.photoThumbUrl"
    [rsvpBadge]="candidateRsvpStatuses[event.candidateId]"
    [rtTooltipTemplate]="avatarTooltipTemplate"
    rtTooltip
  >
    <ng-template #avatarTooltipTemplate>
      <div>
        <b>{{ event.candidate.name }}</b>
      </div>
      @if (
        candidateRsvpStatuses[event.candidateId] &&
        candidateRsvpStatuses[event.candidateId] !== AvatarRsvpBadge.NeedsAction
      ) {
        <div>
          {{ rsvpStatusesTranslationKeys[candidateRsvpStatuses[event.candidateId]] | translate }}
        </div>
      }
    </ng-template>
  </rt-avatar>
}
@if (!onlyCandidate() && event.admins.length !== 0) {
  <div class="vertical-divider"></div>
  @for (admin of event.admins; track admin.id) {
    <rt-avatar
      [type]="
        admin.anonymizedAt ? 'icon' : admin.hasAvatar || !admin.initials ? 'image' : 'initials'
      "
      [size]="'small'"
      [shape]="'oval'"
      [imageSrc]="admin.photoThumbUrl"
      [initials]="admin.initials"
      [rsvpBadge]="adminsRsvpStatuses[admin.id]"
      [rtTooltipTemplate]="avatarTooltipTemplate"
      rtTooltip
      iconName="person"
      context="admin"
      margin-right-small-x
      margin-tb-small-xx
    />
    <ng-template #avatarTooltipTemplate>
      <div>
        <b>{{
          admin.anonymizedAt
            ? ('app.common.deleted_user' | translate)
            : admin.firstName + ' ' + admin.lastName
        }}</b>
      </div>
      @if (
        adminsRsvpStatuses[admin.id] && adminsRsvpStatuses[admin.id] !== AvatarRsvpBadge.NeedsAction
      ) {
        <div>{{ rsvpStatusesTranslationKeys[adminsRsvpStatuses[admin.id]] | translate }}</div>
      }
    </ng-template>
  }
}
